import type { IConversationMessage } from 'src/@types/conversation';
import { conversationMediaState } from '../singleton';

export const useMessageMediaContent = (
  message: IConversationMessage,
  mediaRefKey = 'mediaRef',
) => {
  const mediaContentState = conversationMediaState((s) => ({
    //@ts-expect-error
    mediaContent: s.mediaContent[message[mediaRefKey]],
    getMediaContent: s.getMediaContent,
  }));
  return mediaContentState;
};
